module.exports = __webpack_public_path__ + "img/ssid_chart_black_24dp.e20818dc.svg";